module.exports = __webpack_public_path__ + "images/emoji/baseball.344d2d891f88498a78e4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/baseball.png
// module id = gUKC
// module chunks = 14